export default __webpack_public_path__ + "static/media/burger-background.e510edb1.jpg";